import LocalisedText from "../LocalisedText";
import { VideoIcon } from "../VideoIcon";
import { RewardButton, RewardButtonOpts } from "./RewardButton";

const defaultOpts = {
    buttonTextOffset: -20,
};

export class RewardAdButton extends RewardButton
{
    public adIcon: VideoIcon;
    
    private buttonTextOffset: number;

    constructor(opts: Partial<RewardButtonOpts> = {})
    {
        const o = { ...defaultOpts, ...opts };
        super(o);
        
        this.buttonTextOffset = o.buttonTextOffset;
        
        this.adIcon = new VideoIcon();
        
        this.adIcon.x = (this.btn.bg.width / 2) - 15;
        this.adIcon.rotation = Math.PI * 20 / 180;
        this.btn.icon.addChild(this.adIcon);
        
    }

    public modeWaiting(): void
    {
        super.modeWaiting();
        this.adIcon.animate = false;
    }

    public modeCountdown(): void
    {
        super.modeCountdown();
        this.adIcon.animate = false;
    }

    public modeClaim(): void
    {
        super.modeClaim();
        this.adIcon.animate = true;
    }
    
    public setAdIconVisible(visible: boolean): void
    {
        this.adIcon.visible = visible;
        
        this.buttonText.x = visible ? this.buttonTextOffset : 0;
    }
    
}
